import Masthead from "@/pages/home/components/Masthead";
import HeroSpread from "@/pages/home/components/HeroSpread";
import TopicWall from "@/pages/home/components/TopicWall";
import FeaturedEvents from "@/pages/home/components/FeaturedEvents";
import PhotoBand from "@/pages/home/components/PhotoBand";
import SchoolResponses from "@/pages/home/components/SchoolResponses";
import ChatWall from "@/pages/home/components/ChatWall";
import DisciplineTracker from "@/pages/home/components/DisciplineTracker";
import CommentSection from "@/pages/home/components/CommentSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body text-foreground-900">
      <Masthead />
      <main className="w-full">
        <HeroSpread />
        <TopicWall />
        <FeaturedEvents />
        <PhotoBand />
        <SchoolResponses />
        <ChatWall />
        <DisciplineTracker />
        <CommentSection />
      </main>
      <SiteFooter />
    </div>
  );
}